import { Image, Ref } from "@tblabs/truffle";
import { Box } from "../Utils/Box";


export class NavBarLogo extends Box
{
    constructor(logo: Ref<string>)
    {
        super("navbar__logo", [
            new Image(logo)
                .FloatLeft()
                .CursorPointer()
                .OnClick(() => window.location.hash = "/"),
        ]);
    }
}
            
